import { Exercise, LessonItem } from '@/models/undergrad/undegrad-lesson.model';
import Vue from 'vue';
import { MutationTree } from 'vuex';
import { UndergradLessonState } from './state';

const mutations: MutationTree<UndergradLessonState> = {
  SET_LESSONS(state: UndergradLessonState, entities: UndergradLessonState) {
    if (!entities.undergradLessons) {
      state.undergradLessons = {};
      return;
    }

    state.undergradLessons = { ...state.undergradLessons, ...entities.undergradLessons };
  },

  SET_LESSON_CONTENTS(state: UndergradLessonState, payload: any) {
    const { lessonId, items } = payload;

    Vue.set(state.undergradLessons, lessonId, {
      ...state.undergradLessons[lessonId],
      items,
    });
  },
  SET_LESSON_SOLUTIONS(state: UndergradLessonState, payload: any) {
    const { lessonId, items } = payload;

    Vue.set(state.undergradLessons, lessonId, {
      ...state.undergradLessons[lessonId],
      items,
    });
  },
  ADD_LESSON_REPLY(state: UndergradLessonState, payload: any) {
    const { lessonId, itemId, reply } = payload;

    const lesson = state.undergradLessons[lessonId];

    if (lesson && lesson.items) {
      const lessonItem: LessonItem | undefined = lesson.items.find((item) => item.id === itemId);

      if (lessonItem && lessonItem instanceof Exercise) {
        lessonItem.replies = [reply];

        Vue.set(state.undergradLessons, lessonId, {
          ...state.undergradLessons[lessonId],
          items: [...lesson.items],
        });
      }
    }
  },
  ADD_LESSON_SOLUTION(state: UndergradLessonState, payload: any) {
    const { lessonId, itemId, solutions } = payload;

    const lesson = state.undergradLessons[lessonId];

    if (lesson && lesson.items) {
      const lessonItem: LessonItem | undefined = lesson.items.find((item) => item.id === itemId);

      if (lessonItem && lessonItem instanceof Exercise) {
        lessonItem.solutions = solutions;

        Vue.set(state.undergradLessons, lessonId, {
          ...state.undergradLessons[lessonId],
          items: [...lesson.items],
        });
      }
    }
  },
  ADD_LESSON_COMMENT(state: UndergradLessonState, payload: any) {
    const { lessonId, itemId, comment } = payload;

    const lesson = state.undergradLessons[lessonId];

    if (lesson && lesson.items) {
      const lessonItem: LessonItem | undefined = lesson.items.find((item) => item.id === itemId);

      if (lessonItem && lessonItem instanceof Exercise) {
        lessonItem.comments?.push(comment);

        Vue.set(state.undergradLessons, lessonId, {
          ...state.undergradLessons[lessonId],
          items: [...lesson.items],
        });
      }
    }
  },
};

export default mutations;
